"use strict";

exports.__esModule = true;
var _bottom = _interopRequireDefault(require("./bottom"));
exports.bottom = _bottom.default;
var _left = _interopRequireDefault(require("./left"));
exports.left = _left.default;
var _noBorders = _interopRequireDefault(require("./noBorders"));
exports.noBorders = _noBorders.default;
var _right = _interopRequireDefault(require("./right"));
exports.right = _right.default;
var _top = _interopRequireDefault(require("./top"));
exports.top = _top.default;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/customBorders/contextMenuItem/index.js
// module id = 1329
// module chunks = 0